'use client'

// src/components/spinners/BookingPageSkeleton.tsx
import { twMerge } from "tailwind-merge";
import { AnimatedWbkLogo } from "@wbk/svg";
import { LoadingMessages } from "@wbk/ui";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var BookingPageSkeleton = ({ sideBar = true, className }) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("style", { children: "body{overflow:hidden}" }),
    /* @__PURE__ */ jsxs(
      "section",
      {
        className: twMerge(
          "container flex max-w-screen-2xl flex-col gap-4 overflow-hidden px-0 pb-12 pt-20",
          "lg:mt-0 lg:flex-row lg:overflow-visible lg:px-6 lg:pb-8",
          className
        ),
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex h-[calc(100svh-150px)] grow flex-col items-center justify-center space-y-1 rounded-xl lg:h-auto lg:min-h-[500px]", children: [
            /* @__PURE__ */ jsx(AnimatedWbkLogo, { className: "h-20 w-52 md:h-32 md:w-72 md:py-4" }),
            /* @__PURE__ */ jsx(LoadingMessages, {})
          ] }),
          sideBar && /* @__PURE__ */ jsx("aside", { className: "border-paper hidden min-h-[500px] w-full max-w-lg grow items-center justify-center rounded-xl border lg:block lg:max-w-md" })
        ]
      }
    )
  ] });
};
var BookingPageSkeleton_default = BookingPageSkeleton;

export {
  BookingPageSkeleton_default
};
//# sourceMappingURL=chunk-ZCNSKF47.mjs.map